export const tel = '800 241 242';
export const email = 'info@globus.cz';
